import type { AlertsResponse } from "./types";
import { ForecastError, getApiBaseUrl } from "./client";

export async function fetchAlerts(
  lat: number,
  lon: number,
  options?: { date?: string },
): Promise<AlertsResponse> {
  const url = new URL("/v1/alerts", getApiBaseUrl());
  url.searchParams.set("lat", String(lat));
  url.searchParams.set("lon", String(lon));
  if (options?.date) {
    url.searchParams.set("date", options.date);
  }

  const response = await fetch(url, {
    headers: { Accept: "application/json" },
    signal: AbortSignal.timeout(10_000),
  });

  if (!response.ok) {
    throw new ForecastError(response.status, await response.json().catch(() => null));
  }

  return response.json() as Promise<AlertsResponse>;
}
